'use strict';

import $ from 'jquery';

export default class SiteHeader {
	constructor() {
		this.name = 'site-header';

		const $mobileMenuToggle = $('.mobile-menu-toggle'),
            $navListing = $('.nav__listing'),
            $searchIcon = $('.header__search-icon'),
            $toggleSearchIcon = $searchIcon.find('.icon'),
            $searchContainer = $('.header__search-container'),
            $headerBottom = $('.header__bottom');

		$mobileMenuToggle.on('click', () => {
			$navListing.toggleClass('open');
        });

        $searchIcon.on('click', function(e){
            e.preventDefault();
            $searchContainer.toggleClass('open');
            $headerBottom.toggleClass('search-open');

            if($searchContainer.hasClass('open')) {
                $toggleSearchIcon.removeClass('icon-search').addClass('icon-close');
            } else {
                $toggleSearchIcon.removeClass('icon-close').addClass('icon-search');
            }
        });

        $(document).on('click', (e) => {
            if(!$toggleSearchIcon.is(e.target) && !$toggleSearchIcon.parent().is(e.target)
                && !$searchContainer.is(e.target) && $searchContainer.has(e.target).length === 0) {
                if($searchContainer.hasClass('open')) {
                    $searchContainer.removeClass('open');
                    $headerBottom.removeClass('search-open');
                    $toggleSearchIcon.removeClass('icon-close').addClass('icon-search');
                }
            }
        });
	}
}
